import { render, staticRenderFns } from "./historyAssignMC.vue?vue&type=template&id=88f75584"
import script from "./historyAssignMC.vue?vue&type=script&lang=js"
export * from "./historyAssignMC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports